const formulaRawColumns =[
  {
    dataIndex:'rawName',
    fixed: 'left',
    // title: '原料名称',
    slots: { title: 'customTitle' },
    scopedSlots: {customRender: 'rawName'},
    sorter: (a, b) => a.rawName.localeCompare(b.rawName,'zh'),
    width:220
  },
  {
    dataIndex:'rawCode',
    align:'center',
    title: '原料代码',
    sorter: (a, b) => a.rawCode - b.rawCode,
    sortDirections: ['descend', 'ascend'],
    width:100
  },
  {
    dataIndex:'taskUasgePer',
    align:'center',
    title: '多配方用量(%)',
    scopedSlots: {customRender: 'taskUasgePer'},
    sorter: (a, b) => a.taskUasgePer - b.taskUasgePer,
    sortDirections: ['descend', 'ascend'],
    width:150
  },
  // {
  //   dataIndex:'singUasgePer',
  //   align:'center',
  //   title: '单配方用量(%)',
  //   scopedSlots: {customRender: 'singUasgePer'},
  //   sorter: (a, b) => a.singUasgePer - b.singUasgePer,
  //   sortDirections: ['descend', 'ascend'],
  //   width:150
  // },
  {
    dataIndex:'productRawPercentage',
    align:'center',
    title: '产品(%)',
    scopedSlots: {customRender: 'productRawPercentage'},
    sorter: (a, b) => a.productRawPercentage - b.productRawPercentage,
    sortDirections: ['descend', 'ascend'],
    width:100
  },
  {
    dataIndex:'minValue',
    scopedSlots: {customRender: 'minValue'},
    align:'center',
    title: '最小值',
    sorter: (a, b) => a.minValue - b.minValue,
    sortDirections: ['descend', 'ascend'],
    width:100
  },
  {
    dataIndex:'maxValue',
    scopedSlots: {customRender: 'maxValue'},
    align:'center',
    title: '最大值',
    sorter: (a, b) => a.maxValue - b.maxValue,
    sortDirections: ['descend', 'ascend'],
    width:100
  },
  {
    dataIndex:'uasge',
    align:'center',
    title: '用量(吨)',
    scopedSlots: {customRender: 'uasge'},
    sorter: (a, b) => a.uasge - b.uasge,
    sortDirections: ['descend', 'ascend'],
    width:100
  },
  {
    dataIndex:'productRawUasge',
    align:'center',
    title: '产品(吨)',
    scopedSlots: {customRender: 'productRawUasge'},
    sorter: (a, b) => a.productRawUasge - b.productRawUasge,
    sortDirections: ['descend', 'ascend'],
    width:100
  },
  {
    dataIndex:'cost',
    align:'center',
    title:'单位成本',
    scopedSlots: {customRender: 'cost'},
    sorter: (a, b) => a.cost - b.cost,
    sortDirections: ['descend', 'ascend'],
    width:80
  },
  {
    dataIndex:'minApply',
    align:'center',
    title:'适用下限',
    scopedSlots: {customRender: 'minApply'},
    sorter: (a, b) => a.minApply - b.minApply,
    sortDirections: ['descend', 'ascend'],
    width:100
  },
  {
    dataIndex:'maxApply',
    align:'center',
    title:'适用上限',
    scopedSlots: {customRender: 'maxApply'},
    sorter: (a, b) => a.maxApply - b.maxApply,
    sortDirections: ['descend', 'ascend'],
    width:100
  },
  {
    dataIndex:'minLimitValue',
    scopedSlots: {customRender: 'minLimitValue'},
    align:'center',
    title: '极下限',
    sorter: (a, b) => a.minLimitValue - b.minLimitValue,
    sortDirections: ['descend', 'ascend'],
    width:100
  },
  {
    dataIndex:'maxLimitValue',
    scopedSlots: {customRender: 'maxLimitValue'},
    align:'center',
    title:'极上限',
    sorter: (a, b) => a.maxLimitValue - b.maxLimitValue,
    sortDirections: ['descend', 'ascend'],
    width:100
  },
]

export default formulaRawColumns